/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIResponseError } from './APIResponseError';
import {
    APIResponseErrorFromJSON,
    APIResponseErrorFromJSONTyped,
    APIResponseErrorToJSON,
    APIResponseErrorToJSONTyped,
} from './APIResponseError';
import type { APIMeta } from './APIMeta';
import {
    APIMetaFromJSON,
    APIMetaFromJSONTyped,
    APIMetaToJSON,
    APIMetaToJSONTyped,
} from './APIMeta';

/**
 * 
 * @export
 * @interface APIResponseBase
 */
export interface APIResponseBase {
    /**
     * 
     * @type {APIMeta}
     * @memberof APIResponseBase
     */
    meta?: APIMeta;
    /**
     * 
     * @type {Array<APIResponseError>}
     * @memberof APIResponseBase
     */
    errors?: Array<APIResponseError>;
}

/**
 * Check if a given object implements the APIResponseBase interface.
 */
export function instanceOfAPIResponseBase(value: object): value is APIResponseBase {
    return true;
}

export function APIResponseBaseFromJSON(json: any): APIResponseBase {
    return APIResponseBaseFromJSONTyped(json, false);
}

export function APIResponseBaseFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIResponseBase {
    if (json == null) {
        return json;
    }
    return {
        
        'meta': json['meta'] == null ? undefined : APIMetaFromJSON(json['meta']),
        'errors': json['errors'] == null ? undefined : ((json['errors'] as Array<any>).map(APIResponseErrorFromJSON)),
    };
}

export function APIResponseBaseToJSON(json: any): APIResponseBase {
    return APIResponseBaseToJSONTyped(json, false);
}

export function APIResponseBaseToJSONTyped(value?: APIResponseBase | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'meta': APIMetaToJSON(value['meta']),
        'errors': value['errors'] == null ? undefined : ((value['errors'] as Array<any>).map(APIResponseErrorToJSON)),
    };
}

